import { render, staticRenderFns } from "./ProhibitedWords.vue?vue&type=template&id=89103946"
import script from "./ProhibitedWords.vue?vue&type=script&lang=js"
export * from "./ProhibitedWords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports